import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { withRouter } from 'react-router-dom';
import { Autocomplete } from '@material-ui/lab';
import { getAutocompleteAction, getRequestCountryAction, saveRequestAction, getSearchPassesAction, getSearchAction, getRestore/* removeAction, addSegAction */ } from "../store/actions/index";
import { Grid, Dialog,DialogTitle,DialogContent,DialogActions,DialogContentText,Icon, Button, Hidden, Popper, Typography, Select, MenuItem, InputLabel, FormControl, ListSubheader } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import RemoveIcon from '@material-ui/icons/Remove';
import DeleteIcon from '@material-ui/icons/Delete';
import Datepicker from "../components/Datepicker"
import FormInputSelect from '../components/FormInputSelect'
// import FormInputRangeAge from '../components/FormInputRangeAge'
import FormInputRangeAgePasses from "../components/FormInputRangeAgePasses";
import FormInputText from '../components/FormInputText'
import { getSearchDepartureHour } from '../store/services/InfoFormService'
import CircularProgress from '@material-ui/core/CircularProgress';


class SearchTrainsPasses extends Component {
    // eslint-disable-next-line no-useless-constructor
    constructor(props) {
        super(props);
        this.optionHidden = ''
        this.state = {
            iatafrom: this.props.selectedIatafrom ? this.props.selectedIatafrom : '',
            iatato: '',
            checkin: '',
            request: [{ "origin": {}, "departure": '', "directOnly": false }],
            tramos:  this.props.searchData ? this.props.getSearch.tramos:[{time:"0600"}],
            edades:  [] ,
            msgPassenger:false,
            msg:false,
            timeInput: [],
            ages: [],
            departureInput: [],
            adultos: '',
            jovenes: '',
            menores: '',
            loading: false,
            cantPassAdultos: 10,
            cantPassJovenes: 10,
            cantPassMenores: 10,
            selectDestinyError: null,
            cantPass: 0,
            select: 0,
            searchSelection: {"originDescription": '', "searchDate": ''},
            modalSwitzerlandTrigger: false,
            triggerSwitzerlandOpened: false,
        }
        this.handleCantPasajeros = this.handleCantPasajeros.bind(this);
        this.handlePasajeros = this.handlePasajeros.bind(this);

        this.addEdad = this.addEdad.bind(this);
        this.tokenClient = this.props.getSearch.tokenClient?this.props.getSearch.tokenClient:this.props.match.params.token
        this.apiToken = this.props.apiToken
    }

    componentDidMount () {
        this.props.dispatchGetRequestCountryAction(this.tokenClient);
    }

    UNSAFE_componentWillMount = () => {
        let adultos = 0
        let jovenes = 1
        let menores = 0
        let edadesMenores=[]
        if(this.props.getSearch.edades[0].ageInput !== ''){
            adultos = 0
            jovenes = 0
            menores = 0
            {this.props.getSearch.edades.map((edad, i) => {
                edad.ageInput !== '' &&
                (edad.ageInput >= 60) ? adultos++ :
                    (edad.ageInput < 60 && edad.ageInput > 27) ?  jovenes++ :
                        (edad.ageInput <= 27 && edad.ageInput > 0) && menores++
            })}
        }
		this.setState({ adultos: adultos, jovenes: jovenes, menores: menores});
    }

    UNSAFE_componentWillReceiveProps(next_props) {
		if (this.props.getSearch.edades[0].ageInput !== '')
			this.setState({ edades:  next_props.getSearch.edades.filter(edad =>  edad.ageInput <= 27) });
	}


    handleChangeAutoComplete = (e, name, indice, value) => {

        let key = (name === 'cityFrom') ? 'origin' : 'destination';

        // Seteando valores de autocomplete por tramo
        let tramos = this.state.tramos;
        let request = this.state.request;
        let tramo = this.state.tramos[indice];
        let object = this.state.request[indice];
        tramo[name] = { "code": this.optionHidden.split("-")[0], "type": this.optionHidden.split("-")[1], "value":value };
        tramos[indice] = tramo;

        //Armando el objeto request que nos sirve para el servicio de resultados
        this.setState((prevState) => ({
            tramos: tramos,
            msg: false
        }));

        this.props.dispatchGetAutocomplete(value);
    }

    callback = (value, index, name) => {
        let tramos = this.state.tramos;
        let tramo = this.state.tramos[index];

        if(name == "departure") {
            this.setState(
                prevState => {
                const { searchSelection } = prevState;
                searchSelection['searchDate'] = value;
                return { searchSelection };
                },
                () => {}
            );
        }

        if(tramo===undefined){

            let tramos = this.state.tramos;
            let tramo = this.state.tramos[this.state.tramos.length-1];
            tramo[name] = value
            tramos[this.state.tramos.length-1] = tramo;
            this.setState((prevState) => ({
                tramos: tramos,
            }));

        }else{

            tramo[name] = value
            tramos[index] = tramo;
            this.setState((prevState) => ({
                tramos: tramos,

            }));
        }
    }

    removeEdad = () => {
        if (this.state.edades.length > 1) {
            this.setState((prevState) => {
                const array = [...prevState.edades]
                array.pop()
                return { edades: array }
            })
        }
    }

    evaluateSelectedDestiny = (e) => {
        if (this.state.iatafrom === '') {
            this.setState((prevState) => ({
                selectDestinyError: true,
                // selectDestinyFocus: true,
            }));
        }
    }

    handlePasajeros = (e, value) => {
        let nEdades = e.target.value
    }

    handleSubmit = (e) => {
        let departure = []
        let time = []
        let ages = []
        let origin = []
        let iatafrom = this.state.iatafrom

        const array= []

        let triggerAgeMenor16 = false;




        e.preventDefault();
        this.evaluateSelectedDestiny(e);
        // this.props.dispatchGetRestore()


        for (var i=0; i < this.state.adultos; i++) {
            ages.push('61')
        }
        for (var l=0; l < this.state.jovenes; l++) {
            ages.push('30')
        }

        if(this.state.adultos === 0 && this.state.jovenes === 0){
            this.setState ({ msgPassenger: true  })
        }

        if(this.state.menores > 0){
            this.state.edades.map((value, i) => {
                if (this.state.ages[i].state.defaultValue !== ""){
                    if(this.state.ages[i].state.defaultValue < 28){
                        ages.push(this.state.ages[i].state.defaultValue)
                    }
                    if(this.state.ages[i].state.defaultValue <= 16){
                        triggerAgeMenor16 = true
                    }
                }
            })
        }

        for(var i = 0; i < this.state.tramos.length; i++){
            if(this.state.tramos[i] === undefined){
                this.state.tramos.splice(i , 1);
            }
        }

        this.state.tramos.map((value, i) => {
            if(this.state.tramos[i]!==undefined){
                time.push(value.time)
                departure.push(value.departure.replace("/","-").replace("/","-"))
            }

        })

        // logica Modal caso: destino  Switzerland y menor igual 16
        if ( triggerAgeMenor16 == true && this.state.iatafrom === "CH" && this.state.triggerSwitzerlandOpened == false) {
            this.setState((prevState) => ({
                modalSwitzerlandTrigger: true,
                triggerSwitzerlandOpened: true,
            }));
            return;
        }



        if (!this.state.msgPassenger && iatafrom &&  Object.keys(time).length > 0 && Object.keys(ages).length === (this.state.adultos+this.state.jovenes+this.state.menores) && Object.keys(departure).length > 0) {
            const tramos =  this.state.tramos

            this.props.dispatchGetSearch(iatafrom, departure, time, ages, tramos, this.tokenClient, this.apiToken ,this.state.searchSelection)

            time = time.join(",");
            departure = departure.join(",");
            ages = ages.join("-");
            this.props.history.push("/"+ this.tokenClient +"/trenes/results/passes/" + iatafrom + '/' + departure + '/' + time + '/' + ages)
            this.setState ({ loading: true, msg: false  })
        }

    }

    getSearchSelectAdultos = () => {
        const response = []

        for (var i=0; i < this.state.cantPassAdultos; i++) {
            const arrSelect = {}
            arrSelect['code'] =  i
            arrSelect['description'] = i
            response.push(arrSelect)
        }

        return response;
    }
    getSearchSelectJovenes = () => {
        const response = []
        for (var i=0; i < this.state.cantPassJovenes; i++) {
            const arrSelect = {}
            arrSelect['code'] =  i
            arrSelect['description'] = i
            response.push(arrSelect)
        }

        return response;
    }
    getSearchSelectMenores = () => {
        const response = []
        for (var i=0; i < this.state.cantPassMenores; i++) {
            const arrSelect = {}
            arrSelect['code'] =  i
            arrSelect['description'] = i
            response.push(arrSelect)
        }

        return response;
    }

    addEdad = (cantPass) => {
    this.setState((prevState) => {
            const cantAuxPass = this.state.cantPass
            const array = [...prevState.edades]
            let   cantidadPasajeros = cantPass - cantAuxPass

            for (var i=0; i < Math.abs(cantidadPasajeros); i++) {
                if (cantidadPasajeros > 0 ){
                    const ageCant = {}
                    ageCant['ageInput'] = '';
                    array.push(ageCant)
                }else{
                    array.pop()
                }
            }
            return {cantPass:cantPass, edades: array }
        })
    }

    agesValue = (evt) => {
        this.setState((prevState) => {
            return {
                edades: [...prevState.edades, { ageInput: evt.target.value }],
            }
        });
    }


    handleCantPasajeros = (value,tipo) => {
        this.setState((prevState) => {
            prevState.adultos = tipo === 'adultos' ? value : prevState.adultos
            prevState.jovenes = tipo === 'jovenes' ? value : prevState.jovenes
            prevState.menores = tipo === 'menores' ? value : prevState.menores
            tipo === 'menores' && this.addEdad(value)

            let total  = prevState.adultos + prevState.jovenes + prevState.menores
            let total1 = prevState.jovenes + prevState.menores
            let total2 = prevState.adultos + prevState.menores
            let total3 = prevState.adultos + prevState.jovenes

            return {
                adultos : prevState.adultos,
                jovenes : prevState.jovenes,
                menores : prevState.menores,
                cantPassAdultos: total < 11 ? 11 - total1 : 10,
                cantPassJovenes: total < 11 ? 11 - total2 : 10,
                cantPassMenores: total < 11 ? 11 - total3 : 10,
                msgPassenger: total!=0?false:true

            }
        });

    }

    handleChangeDestiny = (e) => {
        let value = e.target.value
        let originSelection = this.props.country.filter(e=> e.key === value)
        let description = originSelection[0].description
        
        this.setState((prevState) => ({
            selectDestinyError: false,
            iatafrom: value
        }));

        this.setState(
            prevState => {
            const { searchSelection } = prevState;
            searchSelection['originDescription'] = description;
            return { searchSelection };
            },
            () => {}
        );
    }

    render() {
        const {
            tramos,
            /* passengersSelected,
            edades,
            timeInput,
            departureInput,
            ages, */
        } = this.state

        //const autocomplete = this.props.autocomplete;
        //const edadesDisabled = 3

        const GetEdades = (edades) => {
            return (
                <div className="edades-container-wrapper">
                    <div className="edades-container" >
                        {edades.edades.length > 0 &&
                            <Typography color="secondary" display="block" style={{fontSize: 12}}>Ingresa la edad de los pasajeros</Typography>
                        }
                        {edades.edades.length>0 && edades.edades.map((edad, i) => {
                            let ageInput = `ageInput-${i}`
                            return (
                                <div key={i} className={`edad edad-${ageInput} edad-col`}>
                                    <FormInputRangeAgePasses
                                        placeholder="Edad"
                                        id={ageInput}
                                        name={ageInput}
                                        classnamecustom={'edad'}
                                        autoComplete={'off'}
                                        type={'number'}
                                        //  defaultValue={edad.ageInput}
                                        defaultValue={this.state.ages[i]?this.state.ages[i].state.defaultValue!==''?this.state.ages[i].state.defaultValue:edad.ageInput:edad.ageInput}
                                        onChange={this.agesValue}
                                        ref={element => { this.state.ages[i] = element }}
                                    />
                                </div>
                            )
                        })}
                    </div>
                    <Typography className="passenger-leyend" color="secondary" variant="caption" display="block">(Max. 10 pasajeros)</Typography>
                        
                </div>
            )
        }
        /* const GetNumberPicker = () => {
           // const pasajeros = this.state.edades.length
            const pasajeros =  this.state.menores
            return (
                <div className="custom-label MuiFormControl-root">
                    <div className="label-text MuiFormLabel-root MuiInputLabel-formControl">Cantidad de pasajeros</div>
                    <div className="number-picker">
                        <Grid container spacing={0}>
                            <Grid item xs={4}>
                                <Button onClick={this.removeEdad} className="button-left" variant="outlined" disableElevation fullWidth >
                                    <RemoveIcon fontSize="inherit" />
                                </Button>
                            </Grid>
                            <Grid item xs={4}>
                                <FormInputText
                                    placeholder=""
                                    id={`pasajeros`}
                                    name={`pasajeros`}
                                    defaultValue={pasajeros}
                                    onChange={this.handlePasajeros}
                                /></Grid>
                            <Grid item xs={4}>
                                <Button onClick={this.addEdad} variant="outlined" disableElevation fullWidth className="button-right" ><AddIcon fontSize="inherit" /></Button>
                            </Grid>
                        </Grid>
                    </div>
                </div>
            )
        } */

        const GetButton = (props) => {
            const loading = this.state.loading

            return (
                <Fragment>
                    <div className={`containerButtonProgress containerButtonProgressSearch`}>
                        <div className={`wrapperButtonProgress`}>
                            <Button disabled={loading} type="submit" fullWidth variant="contained" color="secondary" className="buttonSearch" >
                                Buscar
                            </Button>
                            {loading && <CircularProgress size={24} color="inherit" className={`buttonProgress`} /> }
                        </div>
                    </div>
                    {/*   {loading &&  <ResultsPage loading={loading} />} */}
                    <Dialog
                        open={this.state.modalSwitzerlandTrigger}
                        onClose={handleCloseDialog}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title">{""}</DialogTitle>
                        <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            Menor de 16 años, viajando con un padre o tutor legal, puede viajar gratis con el Swiss Family Card.
                        </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button  color="secondary" variant="contained"  onClick={this.handleSubmit}>
                                Continuar
                            </Button>
                        </DialogActions>
                    </Dialog>
                </Fragment>
            )
        }
        const handleCloseDialog = () => {
            this.setState((prevState) => ({
                modalSwitzerlandTrigger: false
            }));
        };

        const SelectCountry = (props) => {
            //let country = this.props.country;

            let multiCountry = this.props.country.filter(e=> e.type === "multi_country")
            let popularCountries = this.props.country.filter(e=> e.type === "popular_countries")
            let oneCountry = this.props.country.filter(e=> e.type === "one_country")

            return (
                <Fragment>
                    <FormControl variant="outlined" fullWidth className={`InputForm ${this.props.country.length == 0 && 'disabledInput'}`}
                    >
                    <InputLabel shrink>Destino</InputLabel>
                        { (this.props.country.length === 0) &&
                        <Select value={"Seleccionar..."} >
                            <MenuItem value="seleccionar">Selecccionar...</MenuItem >
                        </Select>
                        }
                        { this.props.country && (this.props.country.length > 0) &&
                        <Select
                            labelId="oringinSelect"
                            id="oringinSelect"
                            value={this.state.iatafrom}
                            error={this.state.selectDestinyError}
                            onChange={this.handleChangeDestiny}
                            displayEmpty
                            >
                                <MenuItem value="" className="placeholder-item" >
                                    <span className="placeholder">Seleccione un destino</span>
                                </MenuItem>
                                <ListSubheader>Multi-País</ListSubheader>
                                {multiCountry.map((country, i) =>
                                    <MenuItem key={i}  value={country.key}>{country.description}</MenuItem >
                                )}
                                <ListSubheader>Países Populares</ListSubheader>
                                {popularCountries.map((country, i) =>
                                    <MenuItem key={i} value={country.key}>{country.description}</MenuItem >
                                )}
                                <ListSubheader>País</ListSubheader>
                                {oneCountry.map((country, i) =>
                                    <MenuItem key={i} value={country.key}>{country.description}</MenuItem >
                                )}
                        </Select>
                        }
                        { this.state.selectDestinyError &&
                            <div className="error">Debe seleccionar un destino</div>
                        }
                    </FormControl>
                </Fragment>
            )
        }

        let dateToday = new Date();
        let maxDateToPasses  = dateToday.setMonth(dateToday.getMonth()+11);

        return (
            <div className="container_buscador" m={1} >
                <form className={`form-search-trains`} onSubmit={this.handleSubmit}   >
                    <Grid container spacing={1}>

                        <Grid item md={11}>
                            <div className={`cont-tramos`}>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} md={9} className="col-dates">
                                        <div className="container">
                                            { tramos.map((tramo,index) => {
                                                if(tramos[index]!==undefined){
                                                    let tramoId = `tramo-${index}`,
                                                        dateFrom = `dateFromInput-${index}`

                                                return (
                                                    <div key={index} className={`tramo ${tramoId}`}>
                                                        {tramo?.iataFrom}
                                                        <Grid container spancing={1}>
                                                            <Grid item xs={12} >
                                                                <Grid container spacing={1}>
                                                                    <Grid item xs={12} md={8} className="cols-autocomplete">
                                                                        <Grid container spacing={1}>
                                                                            <Grid item xs={6}>
                                                                                <SelectCountry/>
                                                                            </Grid>
                                                                            <Grid item xs={6} className="disabledInput">
                                                                                <FormInputSelect
                                                                                    id={''}
                                                                                    name={''}
                                                                                    label=""
                                                                                    defaultValue={'label'}
                                                                                    // optionsSelect={[{'1':'1'}]}
                                                                                    optionsSelect={[{'code':'label', 'description': ''}]}
                                                                                />
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid item xs={12} md={4} className="cols-datepicker-timeselect" >
                                                                        <Grid container spacing={1}>
                                                                            <Grid item xs={6} md={8}>
                                                                                <Datepicker
                                                                                    id={dateFrom}
                                                                                    name={dateFrom}
                                                                                    label="Primer día de validez"
                                                                                    maxDate={maxDateToPasses}
                                                                                    departureValue={tramos[index-1]?.departure}
                                                                                    defaultValue={tramos[index]?.departure}
                                                                                    callbackValue={(date) => this.callback(date, index, "departure")}
                                                                                    ref={element => { this.state.departureInput[index] = element }}
                                                                                />
                                                                            </Grid>
                                                                            <Grid item xs={6} md={4} >
                                                                                <FormControl variant="outlined" fullWidth className="InputForm disabledInput">
                                                                                <InputLabel shrink></InputLabel>
                                                                                    <Select value={"Seleccionar..."} >
                                                                                        <MenuItem value="seleccionar"></MenuItem >
                                                                                    </Select>
                                                                                </FormControl>
                                                                            </Grid>
                                                                        </Grid>
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </div>
                                                )
                                            } })}
                                        </div>
                                    </Grid>
                                    <Grid item xs={12} md={3} className="col-passengers">
                                        <Grid container spacing={1} >
                                            <Grid item xs={4} className="col-picker-number">
                                                <FormInputSelect
                                                    id={`${'jovenes'}`}
                                                    name={`${'jovenes'}`}
                                                // ref={element => { this.state.jovenes = element }}
                                                    label="Adulto"
                                                    //value={this.state.jovenes}
                                                    defaultValue={this.state.jovenes}
                                                // callbackValue={}
                                                    callbackValue={(select) => this.handleCantPasajeros(select,'jovenes')}
                                                    //optionsSelect={this.getSearchSelectJovenes()}
                                                    optionsSelect={this.getSearchSelectJovenes()}
                                                />
                                                <Typography variant="caption" display="block" gutterBottom>(28 a 59 años)</Typography>
                                            </Grid>
                                            <Grid item xs={4} className="col-picker-number">
                                                <FormInputSelect
                                                    id={`${'adultos'}`}
                                                    name={`${'adultos'}`}
                                                //  ref={element => { this.state.adultos = element }}
                                                    label="Senior"

                                                    defaultValue={this.state.adultos}
                                                // value={this.state.adultos}
                                                // callbackValue={}
                                                    callbackValue={(select) => this.handleCantPasajeros(select,'adultos')}
                                                    //optionsSelect={this.getSearchSelectAdultos()}
                                                    optionsSelect={this.getSearchSelectAdultos()}
                                                />
                                                <Typography variant="caption" display="block" gutterBottom>(desde 60 años)</Typography>
                                            </Grid>
                                            <Grid item xs={4} className="col-picker-number">
                                                <FormInputSelect
                                                    id={`${'menores'}`}
                                                    name={`${'menores'}`}
                                                // ref={element => { this.state.menores = element }}
                                                    label="Menor/Joven"
                                                    defaultValue={this.state.menores}
                                                // value={this.state.menores}
                                                    callbackValue={(select) => this.handleCantPasajeros(select,'menores')}
                                                    //optionsSelect={this.getSearchSelectMenores()}
                                                    optionsSelect={this.getSearchSelectMenores()}
                                                />
                                                <Typography variant="caption" display="block" gutterBottom>(hasta 27 años)</Typography>
                                            </Grid>
                                            <Grid item xs={12} className="col-passengers" >
                                                <GetEdades edades={this.state.edades}/>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </div>

                            <div className="cont-controls" style={{visibility:"hidden"}}>
                                <Button startIcon={<Icon>add_box</Icon>} className="buttonLink" color="secondary" size="small" > .
                                </Button>
                            </div>
                        </Grid>

                        <Grid item xs={12} md={1}>
                            <GetButton />

                            {this.state.msgPassenger &&
                            <Typography className="passenger-validation-message" variant="h4">Debe seleccionar al menos un pasajero </Typography>
                            }
                            {this.state.msg &&
                                <Typography className="passenger-validation-message" variant="h4">Debe completar todos los campos </Typography>
                            }
                        </Grid>
                    </Grid>

                </form>
            </div>
        )
    }
}

const mapStateToProps = reducers => {
    return reducers.homeReducer;
};
const mapDispatchToProps = dispatch => {
    return {
        dispatchGetAutocomplete: (query) =>
            dispatch(
                getAutocompleteAction(
                    query
                ),
            ),
        dispatchGetRequestCountryAction: (tokenClient) =>
            dispatch(
                getRequestCountryAction(tokenClient),
            ),
        dispatchSaveRequest: (request) =>
            dispatch(
                saveRequestAction(
                    request
                ),
            ),
        dispatchGetRestore: () =>
            dispatch(
                getRestore()
            ),
        dispatchGetSearch: (origin, departure, time, ages, tramos,tokenClient, searchSelection) => {
            dispatch(
                getSearchPassesAction(origin, departure, time, ages,tramos,tokenClient, searchSelection))
            },
    };
}

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps,
)(SearchTrainsPasses));